export const csFieldClass =
  'w-full rounded-md border border-[var(--glass-border)] bg-[var(--glass-bg)] px-2 py-2 text-sm text-[var(--text-primary)] outline-none focus:border-accent/40'

export const csLabelClass =
  'mb-1 block text-xs font-medium uppercase tracking-wide text-[var(--text-muted)]'
